<template>
    <v-card width="100%" flat>
        <v-card-title class="pb-5">
            <v-row>
                <v-col class="headline pt-0" cols="3" style="min-width: 350px">
                    Statistiky kontroly vstupenek
                </v-col>
                <v-col class="headline pt-0">
                    <v-checkbox
                        dense
                        hide-details
                        class="mt-1"
                        v-model="showEmptyTicketsets"
                        label="Zobrazit prázdné sady"
                    />
                </v-col>
                <v-col class="pt-0">
                    <v-autocomplete
                            clearable
                            hide-details
                            class="pt-0"
                            label="Filtrovat podle události"
                            :items="events"
                            item-value="id"
                            item-text="name"
                            v-model="selectedEvents"
                            multiple
                    ></v-autocomplete>
                </v-col>

                <v-col class="pt-0">
                    <v-autocomplete
                            clearable
                            hide-details
                            class="pt-0"
                            label="Filtrovat podle zařízení"
                            :items="combinedDeviceAndCheckpointList"
                            item-value="id"
                            item-text="name"
                            v-model="selectedDevices"
                            multiple
                    ></v-autocomplete>
                </v-col>
            </v-row>
        </v-card-title>

        <v-card-text>
            <v-row v-if="zones.length" class="mt-3 mb-3">
                <v-col class="pt-0">
                    <v-autocomplete
                        :disabled="zones.length === 0"
                        clearable
                        hide-details
                        class="pt-0"
                        label="Filtrovat podle zóny"
                        :items="zones"
                        item-value="id"
                        item-text="name"
                        v-model="selectedZones"
                        multiple
                    ></v-autocomplete>
                </v-col>

                <v-col class="pt-0">
                    <v-autocomplete
                        :disabled="slots.length === 0"
                        clearable
                        hide-details
                        class="pt-0"
                        label="Filtrovat podle slotu"
                        :items="slots"
                        item-value="id"
                        item-text="name"
                        v-model="selectedSlots"
                        multiple

                    ></v-autocomplete>
                </v-col>
            </v-row>

            <v-row>
                <v-col class="pt-0">
                    <v-select label="Rozlišení dat"
                              :items="dataInterval"
                              item-text="name"
                              item-value="value"
                              v-model="interval"
                    />
                </v-col>
                <v-col class="pt-0">
                    <v-row>
                        <v-col cols="8" class="pt-0 pb-0">
                            <CzDatePicker v-model="dateFrom" label="Od data" />
                        </v-col>
                        <v-col class="pt-0 pb-0">
                            <v-text-field
                                    v-model="dateFromTime"
                                    label="Čas"
                                    hint="HH:MM"
                                    persistent-hint
                            ></v-text-field>
                        </v-col>
                    </v-row>
                </v-col>
                <v-col class="pt-0">
                    <v-row>
                        <v-col cols="8" class="pt-0 pb-0">
                            <CzDatePicker v-model="dateTo" label="Do data" />
                        </v-col>
                        <v-col class="pt-0 pb-0">
                            <v-text-field
                                    v-model="dateToTime"
                                    label="Čas"
                                    hint="HH:MM"
                                    persistent-hint
                            ></v-text-field>
<!--                            prepend-icon="access_time"-->
                        </v-col>
                    </v-row>
                </v-col>
                <v-col class="pt-5" style="max-width: 132px; width: 132px;">
                    <v-btn color="success" @click="reloadList">Zobrazit</v-btn>
                </v-col>
            </v-row>

            <template v-if="stats">
                <v-row>
                    <v-col class="text-right">
                        <v-chip color="success" class="pl-5 pr-5 d-block">
                            Zkontrolováno vstupenek:
                            <strong class="pl-1 pr-1">{{ stats.ticketsValidated }}</strong>
                            ({{ (stats.ticketsValidated / stats.ticketsTotal * 100).toFixed(2) }}%)
                        </v-chip>
                    </v-col>
                    <v-col>
                        <v-chip class="pl-5 pr-5 d-block">
                            Celkem vstupenek:
                            <strong class="pl-1">{{ stats.ticketsTotal }}</strong>
                        </v-chip>
                    </v-col>
                </v-row>

                <v-simple-table dense>
                    <template v-slot:default>
                        <thead>
                            <tr>
                                <th class="text-left">ID</th>
                                <th class="text-left">Akce</th>
                                <th class="text-left">Jméno sady</th>
                                <th class="text-left" width="10%">Ke kontrole</th>
                                <th class="text-left" width="10%">Vstupenek</th>
                                <th class="text-left" width="10%">Osob</th>
                            </tr>
                        </thead>
                        <tbody>
                            <template
                                v-for="item in stats.ticketsetSums"
                            >
                                <tr :key="item.id">
                                    <td>{{ item.id }}</td>
                                    <td>{{ item.eventName }}</td>
                                    <td>{{ item.name }}</td>
                                    <td>{{ item.total }}</td>
                                    <td>{{ item.used }}</td>
                                    <td>
                                        {{ item.real }}
                                        <span v-if="item.real !== item.realNodevice" style="font-size: 85%">
                                            ({{ item.realNodevice }})
                                        </span>
                                    </td>
                                </tr>
                                <tr
                                    v-for="s in item.sub"
                                    :key="s.id"
                                >
                                    <td class="sub text-right" colspan="5">
                                        {{ s.type }} <b>{{ s.name }}</b>
                                    </td>
                                    <td class="sub">{{ s.count }}</td>
                                </tr>
                            </template>
                            <tr style="background: #eee">
                                <td></td>
                                <td></td>
                                <td>{{ stats.ticketsetSumsTotal.name }}</td>
                                <td>{{ stats.ticketsetSumsTotal.total }}</td>
                                <td>{{ stats.ticketsetSumsTotal.used }}</td>
                                <td>{{ stats.ticketsetSumsTotal.real }}</td>
                            </tr>
                        </tbody>
                    </template>
                </v-simple-table>

                <v-divider class="mb-5" />

                <v-row>
                    <v-col v-for="device in stats.device" :key="device.id" cols="6">
                        <v-card elevation="5">
                            <v-card-subtitle class="text-center">
                                <template v-if="device.name || device.username">
                                    {{ device.name }} <span v-if="device.username">({{device.username}})</span> -
                                </template>
                                zkontrolováno vstupenek - <b>{{ device.count }}</b>
                            </v-card-subtitle>
                            <v-card-text>
                                <div>
                                    <Chart :datasets="device.values" :labels="stats.labels" />
                                </div>
                            </v-card-text>
                        </v-card>
                    </v-col>
                </v-row>
            </template>

        </v-card-text>
    </v-card>
</template>

<script>
    import Chart from '../components/Chart'
    import CzDatePicker from '../components/CzDatePicker'
    import moment from 'moment'

    export default {
        components: {
            CzDatePicker,
            Chart
            // Doughnut
        },

        data: () => ({
            selectedEvents: [],
            selectedDevices: [],
            selectedZones: [],
            selectedSlots: [],
            interval: '',
            dateFrom: '',
            dateTo: '',
            dateFromTime: '',
            dateToTime: '',
            showEmptyTicketsets: true,

            dataInterval: [
                {name:'Automaticky', value:''},
                // {name:'Rok', value:'YEAR'},
                // {name:'Měsíc', value:'MONTH'},
                {name:'Den', value:'DAY'},
                {name:'Hodina', value:'HOUR'},
                {name:'Minuta', value:'MINUTE'}
            ]
        }),

        computed: {
            events () {
                return this.$store.state.event.list
            },
            stats () {
                return this.$store.state.statistics.detail
            },
            combinedDeviceAndCheckpointList() {
                const devices = this.$store.state.device.list.map(device => {
                    return {
                        id: `d-${device.id}`,
                        name: `${device.name}`,
                    }
                })
                return devices

                // const checkpoints = this.$store.state.checkpoint.list.map(checkpoint => {
                //     return {
                //         id: `c-${checkpoint.id}`,
                //         name: `Kontrolní místo - ${checkpoint.name}`,
                //     }
                // })
                // return [...devices, ...checkpoints]
            },

            zones() {
                return this.$store.state.user.zones
            },

            slots() {
                let ret = []
                this.selectedZones.forEach(zoneId => {
                    let zone = this.zones.find(row => row.id === zoneId)
                    if (zone && zone.slots) {
                        zone.slots.forEach(slot => {
                            const start = moment(new Date(slot.start)).format('DD.MM.YYYY HH:mm')
                            const end = moment(new Date(slot.end)).format('HH:mm')
                            ret.push({
                                id: slot.id,
                                name: `${zone.name} - ${start.toLocaleString()} - ${end}`
                            })
                        })
                    }
                })
                ret = ret.sort((a, b) => a.name.localeCompare(b.name))
                return ret
            }
        },

        created() {
            this.$store.dispatch('event/list')
            // this.$store.dispatch('checkpoint/list')
            this.$store.dispatch('device/list')
            this.$store.dispatch('user/zones')
        },

        methods: {
            q (query, def, split) {
                if (this.$router.currentRoute.query[query]) {
                    let v = this.$router.currentRoute.query[query]
                    return split ? v.split(',') : v
                } else {
                    return def
                }
            },
            reloadList () {
                // this.$router.push({ name: 'statistics', query: { events: this.selectedEvents.map(row => parseInt(row)).join(',') }})

                this.$store.commit('statistics/setDetail', null)

                let filter = {
                    eventIds: this.selectedEvents.map(row => parseInt(row)),
                    devices: this.selectedDevices,
                    showEmptyTicketsets: this.showEmptyTicketsets
                }
                if (this.interval) {
                    filter.interval = this.interval
                }
                if (this.dateFrom) {
                    if (/^[0-9]{2}:[0-9]{2}$/.test(this.dateFromTime)) {
                        filter.dateFrom = `${this.dateFrom}T${this.dateFromTime}`
                    } else {
                        filter.dateFrom = `${this.dateFrom}T00:00:00`
                    }
                }
                if (this.dateTo) {
                    if (/^[0-9]{2}:[0-9]{2}$/.test(this.dateToTime)) {
                        filter.dateTo = `${this.dateTo}T${this.dateToTime}`
                    } else {
                        filter.dateTo = `${this.dateTo}T23:59:59`
                    }
                }
                if (this.selectedSlots.length) {
                    filter.slots = this.selectedSlots.map(row => parseInt(row))
                } else if (this.selectedZones.length) {
                    filter.zones = this.selectedZones.map(row => parseInt(row))
                }
                this.$store.dispatch('statistics/get', filter)
            },

            onEventsCloseDelayed () {
                this.$nextTick(this.reloadList)
            }
        }
    }
</script>

<style lang="scss">
    .sub {
        background: #efe;
        font-size: 85% !important;
        height: 28px !important;
    }
</style>
